var UICounter = (function ($) {

    UICounter = function () {
        var that = this;

        // DOM

        // CONST

        // DYNAMIC VARS

        // INIT
        that.init();
    };

    UICounter.prototype.class = {
        disabled: 'disabled'
    };
    UICounter.prototype.data_keys = {
        min: 'min',
        max: 'max'
    };
    UICounter.prototype.custom_events = {
        value_changed: 'counter_changed',
        value_changed_manually: 'counter_changed_manually',
        // value_increased: 'counter_increment',
        // value_reduced: 'counter_decrement',
    };

    UICounter.prototype.init = function () {
        var that = this;

        that.initEventHandlers();

        that.setDefaults();
    };

    UICounter.prototype.initEventHandlers = function () {
        var that = this;

        $.sa.$document.on('click', '.js-counter-button-increment', function (e) {
            var $counter = $(this).parent('.js-counter');
            that.increment($counter);

            $counter.trigger(that.custom_events.value_changed_manually, that.getValue($counter));
        });

        $.sa.$document.on('click', '.js-counter-button-decrement', function (e) {
            var $counter = $(this).parent('.js-counter');
            that.decrement($counter);

            $counter.trigger(that.custom_events.value_changed_manually, that.getValue($counter));
        });

        $.sa.$document.on('avia_after_load', function (e) {
            that.setDefaults();
        });
    };

    UICounter.prototype.setDefaults = function () {
        var that = this,
            $counters = $.sa.$document.find('.js-counter');

        // if min, max and value already set in template - disable buttons depending on them
        $counters.each(function () {
            var $counter = $(this),
                $counter_input = $counter.find('.js-counter-input'),
                counter_min = parseInt($counter_input.data(that.data_keys.min), 10),
                counter_max = parseInt($counter_input.data(that.data_keys.max), 10),
                counter_value = parseInt($counter_input.val(), 10);

            if (Number.isInteger(counter_value)) {
                if (Number.isInteger(counter_min)) {
                    if (counter_value <= counter_min) {
                        that._disableDecrement($counter);
                    } else {
                        that._enableDecrement($counter);
                    }
                }

                if (Number.isInteger(counter_max)) {
                    if (counter_value >= counter_max) {
                        that._disableIncrement($counter);
                    } else {
                        that._enableIncrement($counter);
                    }
                }
            }
        });
    };

    /**
     * Increments value of specified counter
     * @param $counter Counter
     */
    UICounter.prototype.increment = function ($counter) {
        this.changeOn($counter, 1);
    };

    /**
     * Decrements value of specified counter
     * @param $counter Counter
     */
    UICounter.prototype.decrement = function ($counter) {
        this.changeOn($counter, -1);
    };

    UICounter.prototype.changeOn = function ($counter, diff) {
        if (diff === 0) {
            return;
        }

        var that = this,
            counter_value = that.getValue($counter),
            value_new = counter_value + diff;

        that.set($counter, value_new);

        // $counter.trigger(
        //     diff > 0 ? that.custom_events.value_increased : that.custom_events.value_reduced, 
        //     {value: value_new, diff: diff}
        // );
    };

    /**
     * Sets specified value to specified counter
     * @param $counter Counter
     * @param value New counter's value
     * @param {boolean} check_limits Whether function should check, is value fits current counter_min and counter_max restrictions
     * @param {boolean} trigger_event Whether event should be triggered
     * @throws CounterValueIsOutOfRangeError|CounterInvalidValueError
     */
    UICounter.prototype.set = function ($counter, value, check_limits = true, trigger_event = true) {
        if (this._isInteger(value) === false) {
            throw new CounterInvalidValueError(value);
        }
        value = parseInt(value, 10);

        var $counter_input = $counter.find('.js-counter-input'),
            counter_min = this.getMin($counter),
            counter_max = this.getMax($counter),
            value_prev = this.getValue($counter),
            value_diff = value - value_prev;

        if (check_limits) {
            // if value doesn't fit counter_min and counter_max restrictions - throw error
            if ((value < counter_min) || (value > counter_max)) {
                throw new CounterValueIsOutOfRangeError(value, counter_min, counter_max);
            }
        }
        // if it does - set value
        $counter_input.attr('value', value);

        if (value === counter_min) {
            this._disableDecrement($counter);
        } else {
            this._enableDecrement($counter);
        }

        if (value === counter_max) {
            this._disableIncrement($counter);
        } else {
            this._enableIncrement($counter);
        }

        if (trigger_event) {
            $counter_input.trigger(this.custom_events.value_changed, {value: value, diff: value_diff});
        }
    };

    // TODO: 
    //  1. если нет вообще аттрибута data-min/data-max
    //  2. если значение - пустое нечисловое (не 0), считать что по этой границе нет лимитов
    /**
     * Sets specified max limit to specified counter
     * @param $counter Counter
     * @param {Integer|String} value New max limit
     * @param {boolean} check_min Whether function should check, is new value compatible with the current min limit
     * @throws CounterInvalidValueError|CounterMaxLessThanMinError
     */
    UICounter.prototype.setMax = function ($counter, value, check_min = true) {
        var $counter_input = $counter.find('.js-counter-input'),
            counter_max_prev = this.getMax($counter),
            counter_min = this.getMin($counter),
            counter_value = this.getValue($counter);

        if (this._isInteger(value) === false) {
            throw new CounterInvalidValueError(value);
        }
        value = parseInt(value, 10);

        if (check_min) {
            // if new max value less than current min value
            if (value < counter_min) {
                // throw error - to catch on the page, so we could display error message
                throw new CounterMaxLessThanMinError(value, counter_min);
            }
        }

        $counter_input.attr('data-' + this.data_keys.max, value); // set value via `attr` to make it clonable

        // if new max value is greater than previous one, or current counter value is lesser than new max value
        if (value > counter_max_prev || counter_value < value) {
            // and increment button was disabled - enable it
            this._enableIncrement($counter);
        }
        // if new max value is lesser (or equal) than previous one, and current counter value is greater or equal than new max value
        else {
            // so disable increment button
            this._disableIncrement($counter);
            // DO NOT SET COUNTER VALUE HERE - because of conflict with passenger-categories-picker component
        }
    };

    /**
     * Sets specified min limit to specified counter
     * @param $counter Counter
     * @param {Integer|String} value New min limit
     * @param {boolean} check_max Whether function should check, is new value compatible with the current max limit
     * @throws CounterInvalidValueError|CounterMinGreaterThanMaxError
     */
    UICounter.prototype.setMin = function ($counter, value, check_max = true) {
        var $counter_input = $counter.find('.js-counter-input'),
            counter_min_prev = this.getMin($counter),
            counter_max = this.getMax($counter),
            counter_value = this.getValue($counter);

        if (this._isInteger(value) === false) {
            throw new CounterInvalidValueError(value);
        }
        value = parseInt(value, 10);

        if (check_max) {
            // if new min value greater than current max value
            if (value > counter_max) {
                // throw error - to catch on the page, so we could display error message
                throw new CounterMinGreaterThanMaxError(value, counter_max);
            }
        }

        $counter_input.attr('data-' + this.data_keys.min, value); // set value via `attr` to make it clonable

        // if new min value is less than previous one
        if (value < counter_min_prev) {
            // and decrement button was disabled - enable it
            this._enableDecrement($counter);
        }
        // if new min value is greater or equal than previous one, and current counter value is less or equal than new min value
        else if (counter_value <= value) {
            // so disable decrement button
            this._disableDecrement($counter);
            // DO NOT SET COUNTER VALUE HERE - because of conflict with passenger-categories-picker component
        }
    };

    /**
     * Returns current max limit of specified counter
     * @param $counter Counter
     * @returns {number}
     */
    UICounter.prototype.getMax = function ($counter) {
        var $counter_input = $counter.find('.js-counter-input'),
            value = $counter_input.attr('data-' + this.data_keys.max); // set value via `attr` to make it clonable
        return parseInt(value, 10);
    }

    /**
     * Returns current max limit of specified counter
     * @param $counter Counter
     * @returns {number}
     */
    UICounter.prototype.getMin = function ($counter) {
        var $counter_input = $counter.find('.js-counter-input'),
            value = $counter_input.attr('data-' + this.data_keys.min); // set value via `attr` to make it clonable
        return parseInt(value, 10);
    }

    /**
     * Returns current value of specified counter
     * @param $counter Counter
     * @returns {number}
     */
    UICounter.prototype.getValue = function ($counter) {
        var $counter_input = $counter.find('.js-counter-input'),
            value = $counter_input.val() || 0;
        return parseInt(value, 10);
    }

    /**
     * Disables counter
     * (for now, it disables manual changes only)
     * @param $counter
     */
    UICounter.prototype.disable = function ($counter) {
        this._disableIncrement($counter);
        this._disableDecrement($counter);
    };

    /**
     * Enables counter
     * (for now, it enables manual changes only)
     * @param $counter
     */
    UICounter.prototype.enable = function ($counter) {
        this._enableIncrement($counter);
        this._enableDecrement($counter);
    };

    /**
     * Private function.
     * Disables increment for specified counter
     * @param $counter Counter
     * @private
     */
    UICounter.prototype._disableIncrement = function ($counter) {
        var $counter_button_increment = $counter.find('.js-counter-button-increment');
        $counter_button_increment.attr('disabled', 'disabled');
        $counter_button_increment.addClass(this.class.disabled);
    }

    /**
     * Private function.
     * Enables increment for specified counter
     * @param $counter Counter
     * @private
     */
    UICounter.prototype._enableIncrement = function ($counter) {
        var $counter_button_increment = $counter.find('.js-counter-button-increment');
        
        if ($counter_button_increment.hasClass(this.class.disabled)) {
            $counter_button_increment.removeClass(this.class.disabled);
        }
        if ($counter_button_increment.attr('disabled')) {
            $counter_button_increment.removeAttr('disabled');
        }
    }

    /**
     * Private function.
     * Disables decrement for specified counter
     * @param $counter Counter
     * @private
     */
    UICounter.prototype._disableDecrement = function ($counter) {
        var $counter_button_decrement = $counter.find('.js-counter-button-decrement'),
            $counter_input = $counter.find('.js-counter-input');

        $counter_button_decrement.attr('disabled', 'disabled');
        $counter_button_decrement.addClass(this.class.disabled);
        // disable input too
        $counter_input.addClass(this.class.disabled);
    }

    /**
     * Private function.
     * Enables decrement for specified counter
     * @param $counter Counter
     * @private
     */
    UICounter.prototype._enableDecrement = function ($counter) {
        var $counter_button_decrement = $counter.find('.js-counter-button-decrement'),
            $counter_input = $counter.find('.js-counter-input');

        if ($counter_button_decrement.hasClass(this.class.disabled)) {
            $counter_button_decrement.removeClass(this.class.disabled);
        }
        if ($counter_button_decrement.attr('disabled')) {
            $counter_button_decrement.removeAttr('disabled');
        }
        // enable input too
        if ($counter_input.hasClass(this.class.disabled)) {
            $counter_input.removeClass(this.class.disabled);
        }
    }

    /**
     * Private function.
     * Checks, is specified value is an integer number
     * @param value
     * @returns {boolean}
     * @private
     */
    UICounter.prototype._isInteger = function (value) {
        return Number.isInteger(parseInt(value, 10));
    };

    return UICounter;
})($);

var CounterMinGreaterThanMaxError = (function ($) {

    CounterMinGreaterThanMaxError = function (min, max) {
        this.name = 'CounterMinGreaterThanMaxError';
        this.min = min;
        this.max = max;
    }

    CounterMinGreaterThanMaxError.prototype = new Error();

    return CounterMinGreaterThanMaxError;
})($);

var CounterMaxLessThanMinError = (function ($) {

    CounterMaxLessThanMinError = function (max, min) {
        this.name = 'CounterMaxLessThanMinError';
        this.max = max;
        this.min = min;
    }

    CounterMaxLessThanMinError.prototype = new Error();

    return CounterMaxLessThanMinError;
})($);

var CounterValueIsOutOfRangeError = (function ($) {

    CounterValueIsOutOfRangeError = function (value, minLimit, maxLimit) {
        this.name = 'CounterValueIsOutOfRangeError';
        this.value = value;
        this.minLimit = minLimit;
        this.maxLimit = maxLimit;
    }

    CounterValueIsOutOfRangeError.prototype = new Error();

    return CounterValueIsOutOfRangeError;
})($);

var CounterInvalidValueError = (function ($) {

    CounterInvalidValueError = function (value) {
        this.name = 'CounterInvalidValueError';
        this.value = value;
    }

    CounterInvalidValueError.prototype = new Error();

    return CounterInvalidValueError;
})($);